// extracted by mini-css-extract-plugin
export var buttonsContainer = "comparisonChart-module--buttonsContainer--f0d31";
export var charcoal = "comparisonChart-module--charcoal--6c4ce";
export var chart = "comparisonChart-module--chart--543b1";
export var collapseIcon = "comparisonChart-module--collapseIcon--1f3f0";
export var comparisonChart = "comparisonChart-module--comparisonChart--4de5e";
export var description = "comparisonChart-module--description--e4e8a";
export var disclaimer = "comparisonChart-module--disclaimer--70f65";
export var displayChart = "comparisonChart-module--displayChart--0fb74";
export var expandIcon = "comparisonChart-module--expandIcon--8ccf7";
export var flag = "comparisonChart-module--flag--2632b";
export var grid = "comparisonChart-module--grid--cc9fe";
export var header = "comparisonChart-module--header--a60c8";
export var headline = "comparisonChart-module--headline--ddbba";
export var textContainer = "comparisonChart-module--textContainer--ab2b4";
export var white = "comparisonChart-module--white--c0f71";